import React from 'react';

function ProviderTable({ providers, onEdit, onDelete, onReset, onTestModels }) {
  return (
    <table className="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Model</th>
          <th>Usage</th>
          <th>Reset</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {providers.map(provider => (
          <tr key={provider.id} className={!provider.is_active ? 'row-inactive' : ''}>
            <td>
              <strong>{provider.name}</strong>
              <br /><small className="text-muted">{provider.base_url}</small>
            </td>
            <td>
              {provider.model_name}
              {provider.alias && (
                <><br /><small className="text-muted">alias: {provider.alias}</small></>
              )}
            </td>
            <td>
              {provider.requests_used}/{provider.request_limit || '∞'} req
              <br />
              <small className="text-muted">{provider.tokens_used}/{provider.token_limit || '∞'} tokens</small>
            </td>
            <td>{provider.reset_at ? new Date(provider.reset_at).toLocaleString() : 'Not set'}</td>
            <td>
              <span className={`badge ${provider.is_active ? 'badge-success' : 'badge-muted'}`}>
                {provider.is_active ? 'Active' : 'Inactive'}
              </span>
              {provider.consecutive_failures > 0 && (
                <><br /><small className="text-error">{provider.consecutive_failures} failures</small></>
              )}
            </td>
            <td>
              <div className="btn-group">
                <button onClick={() => onTestModels(provider)} className="btn btn-sm btn-outline">Test</button>
                <button onClick={() => onEdit(provider)} className="btn btn-sm btn-outline">Edit</button>
                <button onClick={() => onReset(provider.id)} className="btn btn-sm btn-outline">Reset</button>
                <button onClick={() => onDelete(provider.id)} className="btn btn-sm btn-danger">Delete</button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default ProviderTable;
